import { Component, inject, Renderer2 } from '@angular/core';
import { BlockUI } from 'primeng/blockui';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { MobileMenuDrawer } from '../mobile-menu-drawer/mobile-menu-drawer';
import { Overlay } from 'primeng/overlay';
import { SimplebarAngularModule } from 'simplebar-angular';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { AppService } from '../../../services/app.service';
import { LanguageType } from '../../../enum/app.enum';

@Component({
  selector: 'app-header',
  imports: [BlockUI, Button, Drawer, MobileMenuDrawer, Overlay, SimplebarAngularModule, Tab, TabList, Tabs],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  standalone: true
})
export class Header {
  public appService = inject(AppService);
  public isOpenLanguageOrder: boolean = false;
  private renderer = inject(Renderer2);

  /**
   * p-overlay 위치 설정
   * @param wrapper
   */
  setOverlayPositionEnd(wrapper: HTMLDivElement): void {
    const overlayEl = document.body.querySelector('.language-order-overlay.p-overlay');
    if (!overlayEl) return;
    const wrapperRect = wrapper.getBoundingClientRect();
    const right = window.innerWidth - wrapperRect.right;
    this.renderer.removeStyle(overlayEl, 'left');
    this.renderer.setStyle(overlayEl, 'right', right + 'px');
  }

  changeLanguage(language: LanguageType) {
    this.isOpenLanguageOrder = false;
    this.appService.changeLanguage(language);
  }
}
